export default __webpack_public_path__ + "static/media/saint_aubin14.12046a94.jpg";